import { render, staticRenderFns } from "./SurveyManagementEditAttribute.vue?vue&type=template&id=01ee6c98&scoped=true&"
import script from "./SurveyManagementEditAttribute.vue?vue&type=script&lang=js&"
export * from "./SurveyManagementEditAttribute.vue?vue&type=script&lang=js&"
import style0 from "./SurveyManagementEditAttribute.vue?vue&type=style&index=0&id=01ee6c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ee6c98",
  null
  
)

/* custom blocks */
import block0 from "./SurveyManagementEditAttribute.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01ee6c98')) {
      api.createRecord('01ee6c98', component.options)
    } else {
      api.reload('01ee6c98', component.options)
    }
    module.hot.accept("./SurveyManagementEditAttribute.vue?vue&type=template&id=01ee6c98&scoped=true&", function () {
      api.rerender('01ee6c98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-management/edit-question/questions/SurveyManagementEditAttribute.vue"
export default component.exports